import { render } from "./PrivacyNew.vue?vue&type=template&id=5ed742bd&ts=true"
import script from "./PrivacyNew.vue?vue&type=script&lang=ts"
export * from "./PrivacyNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__